import { mapActions } from 'vuex';

//---helpers
import { BLOG_NEWS_TYPE } from '@/helpers';
import { globalLoader } from '@/helpers/variables';
import { toIsoDate } from '@/helpers/blog/author';

//---mixins
import { dynamicHead } from '@/mixins/dynamic-head.js';

//---components
import BreadcrumbsSimple from '@/components/@general/BreadcrumbsSimple/index.vue';
import ContentBlock from '@/components/custom/ContentBlock/index.vue';

export default {
  name: 'Article',
  mixins: [dynamicHead],
  components: { ContentBlock, BreadcrumbsSimple },
  props: {},
  data() {
    return {
      articleType: BLOG_NEWS_TYPE.INTERESTING,
      articleData: null
    };
  },
  created() {
    let { name } = this.$route;
    if (name.indexOf(BLOG_NEWS_TYPE.NEWS) > -1) {
      this.articleType = BLOG_NEWS_TYPE.NEWS;
    }
    this._loadContent();
  },
  mounted() {},
  watch: {},
  computed: {
    breadcrumbs() {
      return this.articleType === BLOG_NEWS_TYPE.NEWS
        ? [{ title: this.$t('page.news.title'), route: { name: 'news' } }]
        : [{ title: this.$t('page.interesting.title'), route: { name: 'interesting' } }];
    }
  },
  methods: {
    ...mapActions({
      getBlogNewsArticle: 'blog/GET_BLOG_NEWS_ARTICLE',
      getBlogInterestingArticle: 'blog/GET_BLOG_INTERESTING_ARTICLE'
    }),
    async _loadContent() {
      globalLoader(true);
      let { slug } = this.$route.params;
      let result = null;
      if (this.articleType === BLOG_NEWS_TYPE.NEWS) {
        result = await this.getBlogNewsArticle(slug);
      } else if (this.articleType === BLOG_NEWS_TYPE.INTERESTING) {
        result = await this.getBlogInterestingArticle(slug);
      }

      this.articleData = result.data;
      this._setMetaParams();
      this.setMeta();
      globalLoader(false);
    },
    _setMetaParams() {
      let { metaTitle, title, metaDescription, image } = this.articleData;
      if (title || metaTitle)
        this.metaParams.title = `${metaTitle ? metaTitle : title}${this.$t('seo.metaTitleGeneral')}`;

      if (metaDescription) this.metaParams.description = metaDescription;
      if (image) this.metaParams.image = image;
      this._setArticleSchema();
    },
    _setArticleSchema() {
      let { title, metaDescription, shortDescription, image, publishedAt, author } = this.articleData;
      let authorData = author?.data;
      let schema = {
        '@type': 'BlogPosting',
        headline: this._stripHtml(title || ''),
        description: this._stripHtml(metaDescription || shortDescription || ''),
        mainEntityOfPage: { '@type': 'WebPage', '@id': this._canonicalUrl() },
        publisher: {
          '@type': 'Organization',
          name: 'Renew',
          logo: { '@type': 'ImageObject', url: `${window.location.origin}/logo.png` }
        }
      };
      if (image) schema.image = image;
      if (publishedAt) schema.datePublished = toIsoDate(publishedAt);
      if (authorData) {
        let { route } = this.$router.resolve(this.$localize({ name: 'author', params: { slug: authorData.slug } }));
        schema.author = { '@type': 'Person', name: authorData.name, url: this._canonicalUrl(route.path) };
      }
      this.setJsonLdSchema('BlogPosting', schema);
    }
  }
};
